import React from "react";
import {
  Lightning,
  ArrowsLeftRight,
  FileText,
  Translate,
  ClockCounterClockwise,
  Lock,
} from "@phosphor-icons/react";
import { useLandingT } from "@/lib/landingI18n";

const features = [
  { icon: <Lightning size={20} weight="duotone" />, key: "f1" },
  { icon: <ArrowsLeftRight size={20} weight="duotone" />, key: "f2" },
  { icon: <FileText size={20} weight="duotone" />, key: "f3" },
  { icon: <Translate size={20} weight="duotone" />, key: "f4" },
  { icon: <ClockCounterClockwise size={20} weight="duotone" />, key: "f5" },
  { icon: <Lock size={20} weight="duotone" />, key: "f6" },
];

export const FeaturesSection = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <section id="features" className="relative py-20 md:py-28 border-t border-white/8">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="kicker">
            <span className="dot" />
            {t("featuresKicker")}
          </div>
          <h2 className="h-section mt-5 text-white">{t("featuresTitle")}</h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((f) => (
            <div
              key={f.key}
              className="glass rounded-2xl p-6 hover:border-emerald-400/30 transition-colors duration-200"
            >
              <div className="feature-tile">{f.icon}</div>
              <h3 className="mt-6 text-lg text-white font-semibold tracking-tight">
                {t(`${f.key}Title`)}
              </h3>
              <p className="mt-2 text-slate-400 text-sm leading-relaxed">
                {t(`${f.key}Body`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
